export class UserParent {
  constructor() {
    this.list = []
  }

  addUser(item) {
    this.list.push(User.buildFromAPI(item))
  }

  updateUser(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, User.buildFromAPI(item))
  }

  removeUser(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => User.buildFromAPI(el))
    }
    return this
  }
}

export class User {
  constructor() {
    this.id = null
    this.login = null
    this.roles = null
    this.userGroups = null
  }

  getForAPI() {
    return {
        id: this.id,
        login: this.login,
        roles: this.roles,
        userGroups: this.userGroups,
      }
  }

  static buildFromAPI(obj) {
    const _this = new User()
    if (obj) {
        _this.id = obj.id
        _this.login = obj.login
        _this.roles = obj.roles
        _this.userGroups = obj.userGroups
      }
    return _this
  }
}
